import { render, staticRenderFns } from "./workspace.vue?vue&type=template&id=5eced694&scoped=true&lang=html&"
import script from "./workspace.vue?vue&type=script&lang=js&"
export * from "./workspace.vue?vue&type=script&lang=js&"
import style0 from "./workspace.vue?vue&type=style&index=0&id=5eced694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eced694",
  null
  
)

component.options.__file = "workspace.vue"
export default component.exports